import { call, put } from 'redux-saga/effects'
import { takeEvery } from 'redux-saga'
import fetcher from 'modules/fetcher'
import {
  FETCH_UNREAD_NOTIFICATIONS,
  FETCH_DISMISSED_NOTIFICATIONS,
  MARK_READ,
  MARK_ALL_SEEN,
  MARK_ALL_READ,
  FETCH_LATEST_NOTIFICATIONS
} from './constants'
import {
  fetchUnreadNotifications,
  fetchDismissedNotifications,
  fetchLatestNotifications,
  fetchUnreadNotificationsSuccess,
  fetchDismissedNotificationsSuccess,
  fetchLatestNotificationsSuccess,
  markAllSeenSuccess
} from './actions'

function * fetchUnreadNotificationsSaga ({ payload }) {
  const { page, perPage } = payload
  try {
    const result = yield call(fetcher, `/notifications?scope=unread&page=${page}&per_page=${perPage}`, { method: 'GET' })
    yield put(fetchUnreadNotificationsSuccess(result))
  } catch (error) {
    console.error(error.message)
  }
}

function * fetchDismissedNotificationsSaga ({ payload }) {
  const { page, perPage } = payload
  try {
    const result = yield call(fetcher, `/notifications?scope=read&page=${page}&per_page=${perPage}`, { method: 'GET' })
    yield put(fetchDismissedNotificationsSuccess(result))
  } catch (error) {
    console.error(error.message)
  }
}

function * fetchLatestNotificationsSaga () {
  try {
    const result = yield call(fetcher, '/notifications/latest', { method: 'GET' })
    yield put(fetchLatestNotificationsSuccess(result))
  } catch (error) {
    console.error(error.message)
  }
}

function * markReadSaga ({ payload }) {
  const { id, currentUnreadPage, currentUnreadPerPage, currentDismissedPage, currentDismissedPerPage } = payload
  try {
    yield call(fetcher, `/notifications/${id}/mark_read`, { method: 'POST' })
    yield put(fetchUnreadNotifications({ page: currentUnreadPage, perPage: currentUnreadPerPage }))
    yield put(fetchDismissedNotifications({ page: currentDismissedPage, perPage: currentDismissedPerPage }))
    yield put(fetchLatestNotifications())
  } catch (error) {
    console.error(error.message)
  }
}

function * markAllSeenSaga ({ payload }) {
  const { ids } = payload
  try {
    yield call(fetcher, '/notifications/mark_all_seen' + idParams(ids), { method: 'POST' })

    if (ids.length > 0) {
      yield put(markAllSeenSuccess(ids))
    } else {
      yield put(fetchUnreadNotifications())
      yield put(fetchDismissedNotifications())
      yield put(fetchLatestNotifications())
    }
  } catch (error) {
    console.error(error.message)
  }
}

function * markAllReadSaga ({ payload }) {
  const { ids } = payload
  try {
    yield call(fetcher, '/notifications/mark_all_read' + idParams(ids), { method: 'POST' })
    yield put(fetchUnreadNotifications())
    yield put(fetchDismissedNotifications())
    yield put(fetchLatestNotifications())
  } catch (error) {
    console.error(error.message)
  }
}

export function * watchNotificationsFetchedSaga () {
  yield takeEvery(FETCH_UNREAD_NOTIFICATIONS, fetchUnreadNotificationsSaga)
  yield takeEvery(FETCH_DISMISSED_NOTIFICATIONS, fetchDismissedNotificationsSaga)
  yield takeEvery(FETCH_LATEST_NOTIFICATIONS, fetchLatestNotificationsSaga)
  yield takeEvery(MARK_READ, markReadSaga)
  yield takeEvery(MARK_ALL_SEEN, markAllSeenSaga)
  yield takeEvery(MARK_ALL_READ, markAllReadSaga)
}

export const notificationsFetchedSagas = [watchNotificationsFetchedSaga()]

const idParams = (ids) => ids.length > 0 ? '?ids=' + ids.join(',') : ''
